import api from './api';
import type {
  PosStore,
  PosLiveSession,
  PosStaff,
  PosGoldQuote,
  CreatePosOrderPayload,
  CreatePosOrderResponse,
  PosCustomerSearchResponse,
  PosVariantSearchResult,
  PosVariantDetailResponse,
  PosAvailableSerial,
  FulfillmentMode,
} from '@/pages/POS/types';

export const posService = {
  searchVariant: (qr: string, fulfillmentType: FulfillmentMode) =>
    api
      .get<PosVariantSearchResult>('/pos/variants', {
        params: { qr, fulfillment_type: fulfillmentType },
      })
      .then((r) => r.data),

  lookupVariants: (qrCodes: string[], fulfillmentType: FulfillmentMode) =>
    api
      .post<PosVariantDetailResponse>('/pos/variants/lookup', {
        qr_codes: qrCodes,
        fulfillment_type: fulfillmentType,
      })
      .then((r) => r.data),

  // store_id auto-inject bởi interceptor; BE resolve store của ca từ TenantContext.
  listVariantSerials: (variantId: string, params: { q?: string; warehouse_id?: string }) =>
    api
      .get<{ items: PosAvailableSerial[] }>(`/pos/variants/${variantId}/serials`, { params })
      .then((r) => r.data.items),

  createOrder: (body: CreatePosOrderPayload) =>
    api
      .post<{ success: boolean; data: CreatePosOrderResponse }>('/pos/orders', body)
      .then((r) => r.data.data),

  searchCustomers: (q: string, page = 1, limit = 20) =>
    api
      .get<PosCustomerSearchResponse>('/pos/customers', { params: { q, page, limit } })
      .then((r) => r.data),

  getCurrentQuotes: () =>
    api.get<{ data: PosGoldQuote[] }>('/pos/quotes/current').then((r) => r.data.data ?? []),

  // storeId không cần truyền — axios interceptor auto-inject ?store_id=<sessionStorage>
  // và BE TenantMiddleware resolve từ đó (EG-369). Naming snake_case theo ADR-013.
  getStaffList: () =>
    api
      .get<{ data: PosStaff[] }>('/pos/staff')
      .then((r) => r.data.data ?? []),

  getMyStores: () =>
    api.get<{ data: PosStore[] }>('/pos/stores').then((r) => r.data.data ?? []),

  getLiveSessions: () =>
    api
      .get<{ data: PosLiveSession[] }>('/pos/live-sessions')
      .then((r) => r.data.data ?? []),

  voidOrder: (body: { orderId: string; reason: string }) =>
    api.post('/pos/void/order', body).then((r) => r.data),

  voidItem: (body: { orderId: string; itemId: string; reason: string }) =>
    api.post('/pos/void/item', body).then((r) => r.data),
};
